import { createBtn, createBtnWithSpinner, createEl, createElWithHTML, createElWithText, createFragment } from "../../../../helpers/dom-creators.js";
import { $ } from "../../../../helpers/dom-selectors.js";
import Overlay from "../../../global-components/overlay.js";
import emitEventWithData from "../init/form-events.js";
export default function makeDiscountForm({ form, overlayEl }) {
    let initialized = false;
    let FORM;
    let PROMPT;
    return Object.freeze({
        init,
        updateID,
        updateCode
    });
    function init() {
        if (initialized)
            return;
        PROMPT = new Overlay(overlayEl);
        FORM = {
            form,
            formID: form.getAttribute('data-id'),
            submitBtn: $(form, '.submit-btn')[0]
        };
        _addListeners();
        initialized = true;
    }
    function _addListeners() {
        FORM.form.addEventListener('submit', _onFormSubmit);
    }
    function _onFormSubmit(e) {
        e.preventDefault();
        const { form, submitBtn } = FORM;
        if (!FORM.formID) {
            emitEventWithData('discount-created', { form, submitBtn });
            return;
        }
        _renderConfirmationPopup(FORM.formID);
    }
    function updateID(id) {
        FORM.formID = id;
    }
    function updateCode(code) {
        FORM.form.discountcode.value = code;
        FORM.form.discountcode.parentElement.classList.remove('no-display');
    }
    function _renderConfirmationPopup(id) {
        const confirmBtn = createBtnWithSpinner('btns submit-btn', { type: 'button', text: 'Yes', title: 'Yes' });
        const cancelBtn = createBtn('btns submit-btn error-btn', { type: 'button', text: 'No', title: 'No' });
        const form = createEl('form', 'flex-container flex-center prompt-btns');
        form.append(confirmBtn, cancelBtn);
        const fragments = [
            createElWithText('h1', 'text-center', `Generate Code`),
            createElWithHTML('p', 'text-center', `Are you sure you want to generate a new code? The previous code will be replaced and will no longer be valid.`),
            form
        ];
        const fragment = createFragment(fragments);
        PROMPT.render(fragment);
        confirmBtn.addEventListener('click', (e) => {
            emitEventWithData('discount-updated', {
                id,
                form: FORM.form,
                submitBtn: confirmBtn
            });
        });
        cancelBtn.addEventListener('click', (e) => PROMPT.hide());
    }
}
